/* Add gift product to cart */

window.addGiftProduct = async function(gift_data) {
  var productData = {
    'items': gift_data
  };
  var result = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(productData)
  })

  if (result.status === 200) {
    return result.json();
  }

  throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}

/* Remove gift product from cart */

window.removeGiftProduct = async function(gift_data) {
  gift_data = Object.assign({}, gift_data);

  var productData = {updates: gift_data};

  var result = await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(productData)
  });

  if (result.status === 200) {
    return result.json();
  }

  throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}

/* Clear cart */

window.clearCart = async function() {
  var result = await fetch('/cart/clear.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })

  if (result.status === 200) {
    return result.json();
  }

  throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}
window.getCart = async function () {
  var result = await fetch(window.routes.root_url + '/cart?view=cartJson', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  if(result.status === 200) {
    return result.json();
  }

  throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}

window.promotionValidate = async function () {
  var gwpList = window.promotionSettings.gwp, giftToAdd = [], giftToRemove = [], conditionArray = [];
  const exchangeRate = parseFloat(window.Shopify.currency.rate);
  const excludeSellingPlanNames = window.promotionSettings.excludeSellingPlanNames?window.promotionSettings.excludeSellingPlanNames.split(","):[]
  const groupBConfig = window.freeShipping?.shipping?.[0]?.newCustomerGroupB || {};
  const groupBGiftProductId = groupBConfig.sellingGiftProductId;

  await window.getCart().then(async function(response) {
    if(response) {
      window.cartItemsData = [];
      window.cartItemsData.productData = [];
      window.cartItemsData.giftsInCart = [];
      window.cartItemsData.cartTotal = 0;

      let total_price = response.total_price

      response['items'].forEach(function (item) {
        const giftSource = item.properties && item.properties._source;
        const isGroupBGift =
          giftSource === 'new-customer-group-b' ||
          (giftSource === 'cart-claim' &&
            groupBGiftProductId != null &&
            String(item.product_id) === String(groupBGiftProductId));
        let hasSellingPlan = false
        excludeSellingPlanNames.forEach(selling_item => {
            if(item.selling_plan && item.selling_plan.name.includes(selling_item)){
                hasSellingPlan = true
                total_price = total_price - item.line_price
            }
        })
        if(item.product_type.toLowerCase() != "gwp" && !isGroupBGift) {
          window.cartItemsData.productData.push({
            id: item.id,
            productID: item.product_id.toString(),
            quantity: item.quantity,
            price: (item.line_price / 100),
          })
        } else {
          window.cartItemsData.giftsInCart.push(item.id)
        }
      });
      // Convert cart total to USD before comparison
      window.cartItemsData.cartTotal = (total_price / 100) / exchangeRate;      
    }

    if(window.cartItemsData.productData.length > 0 || window.cartItemsData.giftsInCart.length > 0) {
      gwpList.forEach((promotion) => {
        if(promotion.minimumCartAmount != false) {
          conditionArray.push("minimumCartAmount");
        }
        
        // Compare USD cart total with USD threshold
        if(promotion.minimumCartAmount && 
           promotion.giftInventory > promotion.minimumGiftQuantity && 
           window.cartItemsData.cartTotal >= parseInt(promotion.minimumCartAmount) && 
           !promotion.conditionArray.includes("minimumCartAmount")) {
          promotion.conditionArray.push("minimumCartAmount");
        }

        /* Compare both arrays (all options in cart and fulfilled option) */
        if(conditionArray.length == promotion.conditionArray.length) {
          promotion.isCriteriaMeet = true;
        }
        if(promotion.isCriteriaMeet) {
          if(promotion.enable && promotion.available && !window.cartItemsData.giftsInCart.includes(promotion.varID)) {
            giftToAdd.push({id: promotion.varID, quantity: 1});
          }
        } else {
          if(promotion.enable && window.cartItemsData.giftsInCart.includes(promotion.varID)) {
            giftToRemove[promotion.varID] = 0;
          }
        }
        conditionArray = [];
        promotion.isCriteriaMeet = false;
        promotion.conditionArray = [];
      });
    }

    /* Add gifts to the cart */

    if(giftToAdd.length > 0) {
      console.log(giftToAdd, 'giftToAdd')
      addProduct = await window.addGiftProduct(giftToAdd);
    }

    /* Remove gifts from the cart */

    if(Object.keys(giftToRemove).length != 0) {
      console.log(giftToRemove, 'giftToRemove')
      removeProduct = await window.removeGiftProduct(giftToRemove)
    }
  });
}

window.getCart().then(async function(response) {
  if(response) {
    var totalSavings = 0, totalSavingsValue = 0;
    response.items.filter(item => {
      const compare_at_price = item.compare_at_price
      if(compare_at_price != null) {
        totalSavings = totalSavings + (compare_at_price - item.original_price) * item.quantity;
      }
    })
    // compute total savings
    totalSavingsValue = formatMoney(totalSavings)
    // Update Cart Savings
    // document.getElementById('cart-savings').innerHTML = '-' + totalSavingsValue
  }
})

window.pmoBuyXgetY = async function(param = null) {
  const pmo = window.pmoBuyXgetYSettings,
        pmoEnable = pmo.enable,
        productData = [],
        productDataRemove = [],
        customerTier = pmo.customerTier,
        minimumCartAmount = pmo.minimumCartAmount,
        pmoProductx = pmo.pmoProduct,
        pmoProductxFree = pmo.pmoFreeProduct,
        pmoProductGenralFree = pmo.pmoFreeProduct2,
        excludeSellingPlanNames = pmo.excludeSellingPlanNames?pmo.excludeSellingPlanNames.split(","):[];

  if (pmoEnable) {
    await window.getCart().then(async function(cartData) {
      if (cartData) {
        for (let index = 0; index < pmoProductx.length; index++) {
          const pmoProductx_item = pmoProductx[index];
          // Skip slots that Liquid left empty (product blank or promo disabled)
          if (!pmoProductx_item || !pmoProductx_item.productId || !pmoProductxFree[index] || !pmoProductxFree[index].varID || pmoProductxFree[index].varID === 'xxx') continue;
          const excludedVariantIDs = pmoProductx[index].excludedVariantIDs;

          const checkProductxVariantID = (variantID) => {
            let variantIDArray = excludedVariantIDs.split(",");
            return variantIDArray.some(id => id == variantID);
          }

          let total_price = cartData.total_price
          const cartItem = cartData.items.filter(item => {
                  let hasSellingPlan = false
                  excludeSellingPlanNames.forEach(selling_item => {
                      if(item.selling_plan && item.selling_plan.name.includes(selling_item)){
                          hasSellingPlan = true
                          total_price = total_price - item.line_price
                      }
                  })
                  return !hasSellingPlan;
              }),
                qualifiedXProduct = cartItem.filter(item => (item.product_id == pmoProductx[index].productId && !checkProductxVariantID(item.variant_id))),
                ispmoProductx = cartItem.filter(item => item.product_id == pmoProductx[index].productId).length > 0,
                ispmoProductxFree = cartItem.filter(item => item.id == pmoProductxFree[index].varID).length > 0,
                ispmoProductGenralFree = cartItem.filter(item => item.id == pmoProductGenralFree[0].varID).length > 0,
                pmoProductVariantIDs = pmoProductx[index].listVariantID;


          // check the cart if the Product X exists
          let removeFreeProduct = cartItem.filter(product => {
            const variantID = product.variant_id;
            return pmoProductVariantIDs.includes(product.id) && !checkProductxVariantID(variantID);
          }).length > 0 ? false : true;

          // Check if qualified product x is in cart, if yes add free product
          let addFreeProduct = (excludedVariantIDs === "" || (excludedVariantIDs != "" && qualifiedXProduct.length > 0));


          if (!ispmoProductxFree && ispmoProductx && pmoProductxFree[index].available && addFreeProduct) {
            productData.push({id: pmoProductxFree[index].varID, quantity: 1 });
          }

          if (!ispmoProductGenralFree && pmoProductGenralFree[0].available) {
            // productData.push({id: pmoProductGenralFree[0].varID, quantity: 1})
          }

          if (ispmoProductxFree && pmoProductxFree[index].available && removeFreeProduct) {
            productDataRemove[pmoProductxFree[index].varID] = 0;
          }

          // console.log("checkProductxVariantTitle", checkProductxVariantTitle(variantTitle))
          // console.log("removeFreeProduct", removeFreeProduct)
          // console.log("addFreeProduct", addFreeProduct)
          // console.log("====================")
          // console.log(ispmoProductx, ispmoProductxFree ,pmoProductxFree[index].available)

          //   else {
          //   if(ispmoProductx && qualifiedXProduct.length > 0) {
          //     if(productData.length > 0){
          //       await window.addGiftProduct(productData);
          //     }
          //   }else {
          //     // console.log("productDataRemove2", productDataRemove)
          //     await window.removeGiftProduct(productDataRemove)
          //   }
          // }
        }

        // Cart subtotal is greater than or equal to the minimumCartAmount threshold
       
        if(productData.length > 0) {
          await window.addGiftProduct(productData);
        }
        if(productDataRemove) {
          await window.removeGiftProduct(productDataRemove)
        }

        if (param == 'reload') {
          window.location.reload();
        }
      }
    });
  } else {
    pmoProductxFree.forEach((pmoProductxFree_item,index) => {
      if (pmoProductxFree[index].available) {
        productDataRemove[pmoProductxFree[index].varID] = 0;
      }
    })
    if (pmoProductGenralFree[0].available) {
      productDataRemove[pmoProductGenralFree[0].varID] = 0;
    }
    await window.removeGiftProduct(productDataRemove);
  }
}
